import { useCallback, useEffect, useRef, useState } from 'react';

// Whole-second countdown driven by the wall clock (stays accurate when the tab is throttled).
// start(seconds) begins counting down; `remaining` is 0 when idle or finished.
export function useCountdown() {
  const [remaining, setRemaining] = useState(0);
  const untilRef = useRef(0);
  const active = remaining > 0;

  useEffect(() => {
    if (!active) return undefined;
    const id = setInterval(() => {
      setRemaining(Math.max(0, Math.ceil((untilRef.current - Date.now()) / 1000)));
    }, 1000);
    return () => clearInterval(id);
  }, [active]);

  const start = useCallback((seconds) => {
    const s = Math.max(0, Math.ceil(Number(seconds) || 0));
    untilRef.current = Date.now() + s * 1000;
    setRemaining(s);
  }, []);

  return { remaining, start };
}
